/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stat_Seekers_LabelInputs */

const en_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumes tailored`)
};

const de_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebensläufe erstellt`)
};

const fr_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV personnalisés`)
};

const es_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CVs personalizados`)
};

const it_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV personalizzati`)
};

const nl_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV's op maat`)
};

const pl_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV dostosowane`)
};

const fi_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Räätälöityjä CV:itä`)
};

const da_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skræddersyede CV'er`)
};

const sv_landing_stat_seekers_label = /** @type {(inputs: Landing_Stat_Seekers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skräddarsydda CV:n`)
};

/**
* | output |
* | --- |
* | "Resumes tailored" |
*
* @param {Landing_Stat_Seekers_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stat_seekers_label = /** @type {((inputs?: Landing_Stat_Seekers_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stat_Seekers_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stat_seekers_label(inputs)
	if (locale === "fr") return fr_landing_stat_seekers_label(inputs)
	if (locale === "es") return es_landing_stat_seekers_label(inputs)
	if (locale === "it") return it_landing_stat_seekers_label(inputs)
	if (locale === "nl") return nl_landing_stat_seekers_label(inputs)
	if (locale === "pl") return pl_landing_stat_seekers_label(inputs)
	if (locale === "fi") return fi_landing_stat_seekers_label(inputs)
	if (locale === "da") return da_landing_stat_seekers_label(inputs)
	if (locale === "sv") return sv_landing_stat_seekers_label(inputs)
	return en_landing_stat_seekers_label(inputs)
});